import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ShippingZone = () => {
    const [formData, setFormData] = useState({
        state: '',
        zipcode: '',
        price: '',
    });


    const [shippingZones, setShippingZones] = useState([]); // State to store fetched data
    const [editMode, setEditMode] = useState(false); // State to toggle edit mode
    const [editId, setEditId] = useState(null); // State to store the ID of the item being edited
    const canadianProvincesAndTerritories = [
           { code: 'Pun', name: 'Punjab' },
    { code: 'Sin', name: 'Sindh' },
    { code: 'Kpk', name: 'KPK' },
    { code: 'Bal', name: 'Balochistan' },
   
      ];
    // Fetch data from the backend
    useEffect(() => {
        fetchShippingZones();
    }, []);

    const fetchShippingZones = async () => {
        try {
            const response = await axios.get('api/shippingzones/all'); // Replace with your API endpoint
            setShippingZones(response.data);
        } catch (error) {
            console.error('Error fetching shipping zones:', error);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (editMode) {
                // Update existing record
                await axios.put(`api/shippingzone/${editId}`, formData);
                alert('Shipping zone updated successfully!');
            } else {
                // Create new record
                await axios.post('api/post/shippingzone', formData);
                alert('Shipping zone created successfully!');
            }

            // Reset form and fetch updated data
            setFormData({ state: '', zipcode: '', price: '' });
            setEditMode(false);
            setEditId(null);
            fetchShippingZones();
        } catch (error) {
            console.error('Error:', error.response?.data || error.message);
            alert('Failed to process request. Check the console for details.');
        }
    };

    const handleEdit = (zone) => {
        // Set form data for editing
        setFormData({
            state: zone.state,
            zipcode: zone.zipcode,
            price: zone.price,
        });
        setEditMode(true);
        setEditId(zone.id);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`api/delete/shippingzone/${id}`);
            alert('Shipping zone deleted successfully!');
            fetchShippingZones(); // Refresh the table
        } catch (error) {
            console.error('Error deleting shipping zone:', error);
        }
    };
    const handleProvinceChange = (e) => {
        //setSelectedProvince(e.target.value);
        setFormData({...formData,[e.target.name]:e.target.value});
        
      };
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
            {/* Form */}
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md w-full max-w-md mb-8">
                <h2 className="text-2xl font-bold mb-6 text-center">
                    {editMode ? 'Edit Shipping Zone' : 'Add Shipping Zone'}
                </h2>

                {/* State Input */}
                <div className="mt-10">
            <p className="text-sm font-bold text-red-500">Province</p>
            <select
              id="province"
              name="state"
              value={formData.state}
              onChange={handleProvinceChange}
              className="mt-1 block w-full p-4 border border-gray-400 rounded-md  focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">-- Select --</option>
              {canadianProvincesAndTerritories.map((province) => (
                <option key={province.code} value={province.code}>
                  {province.name}
                </option>
              ))}
            </select>
          </div>

                {/* Zipcode Input */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Zipcode:</label>
                    <input
                        type="text"
                        name="zipcode"
                        value={formData.zipcode}
                        onChange={handleChange}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter zipcode"
                    />
                </div>

                {/* Price Input */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Price:</label>
                    <input
                        type="number"
                        name="price"
                        value={formData.price}
                        onChange={handleChange}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter price"
                    />
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300"
                >
                    {editMode ? 'Update' : 'Submit'}
                </button>
            </form>

            {/* Table */}
            <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-4xl">
                <h2 className="text-2xl font-bold mb-6 text-center">Shipping Zones</h2>
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="bg-gray-200">
                            <th className="p-3 text-left">State</th>
                            <th className="p-3 text-left">Zipcode</th>
                            <th className="p-3 text-left">Price</th>
                            <th className="p-3 text-left">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {shippingZones.map((zone) => (
                            <tr key={zone.id} className="border-b">
                                <td className="p-3">{zone.state}</td>
                                <td className="p-3">{zone.zipcode}</td>
                                <td className="p-3">{zone.price}</td>
                                <td className="p-3">
                                    <button
                                        onClick={() => handleEdit(zone)}
                                        className="mr-2 text-blue-500 hover:text-blue-700"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => handleDelete(zone.id)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ShippingZone;